import React from 'react'
import { Button, Spinner } from 'react-bootstrap'

type Props = {
  isSubmitting?: boolean;
  disabled?: boolean;
  onClick?: (e?: any) => void;
  children?: React.ReactNode;
  variant?: string;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  submittingText?: React.ReactNode;
}

export default function SubmitButton({
  isSubmitting = false,
  disabled = false,
  onClick,
  children,
  variant = 'primary',
  className = '',
  type = 'button',
  submittingText,
}: Props) {
  return (
    <Button
      variant={variant}
      className={className}
      disabled={disabled || isSubmitting}
      onClick={onClick}
      type={type}
    >
      {isSubmitting && (
        <Spinner animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />
      )}
      {isSubmitting ? (submittingText ?? children) : children}
    </Button>
  )
}
 